import React from 'react';

import { Level, Title } from 'rbx';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 1rem;
  .level:not(:last-child) {
    margin-bottom: 0;
  }
`;

const Header = ({ loading, handleSubmit, next, prev }) => (
  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Title className="is-size-2">Place Reviews</Title>
      </Level.Item>
    </Level>
  </Wrapper>
);

export default Header;
